import Box from "../../../components/layout/Box";
import { FormValues, Fuel } from "../../Form";
import { Text } from "../../../components/typography/Text";
import Heading from "../../../components/typography/Heading";
import { TypePicker } from "../../../components/form/TypePicker";
import { useFormikContext } from "formik";
import { 
  useBrandsQuery, 
  useFuelsQuery, 
  useModelsQuery, 
  // useYearsQuery 
} from "../../../queries/integrations/back_end";
import { 
  CssTextField, 
  // CssSelect 
} from "../../../components/form/CssField";
import {
  Autocomplete,
  // Button
  // MenuItem,
  // SelectChangeEvent,
} from "@mui/material";
// import { styled } from '@mui/material/styles';
// import ButtonBase from '@mui/material/ButtonBase';

import InputGroup from "../../../components/form/InputGroup";
import { SimulatorLayout, TotalSteps } from "./private/SimulatorLayout";
import SliderInput from "../../../components/form/SliderInput";

const CarComponent = () => {
  const { values, setFieldValue } = useFormikContext<FormValues>();
  const { data: brands } = useBrandsQuery();
  // const { data: models = [], isLoading: isModelsLoading } = useModelsQuery(values.vehicle.brand);
  const { data: models = [] } = useModelsQuery(values.vehicle.brand);
  const { data: availableFuels = [] } = useFuelsQuery(values.vehicle.brand, values.vehicle.model);
  // const { data: availableYears = [] } = useYearsQuery(values.vehicle.brand, values.vehicle.model, values.vehicle.fuel);

  if (!brands) return null;

  // sorting
  brands.sort();
  models.sort();

  let shouldDisplayConsumptionInput;
  if (values.vehicle.brand !== "unknown" &&
  values.vehicle.model !== "unknown") {
    shouldDisplayConsumptionInput = true;
  } else {
    shouldDisplayConsumptionInput = false;
  }

  return (
    <Box col mw="300px">
      <Heading marginY="m0" size="h5" uppercase="true">Votre véhicule</Heading>
      <TypePicker.Root fieldName="vehicle[type]">
        <TypePicker.Label as={Text}>Quel véhicule avez-vous ?</TypePicker.Label>
        <TypePicker.OptionsGroup direction="row">
          <TypePicker.Option value="car">VOITURE</TypePicker.Option>
          <TypePicker.Option value="bike">MOTO</TypePicker.Option>
        </TypePicker.OptionsGroup>
      </TypePicker.Root>
      
      <InputGroup gap="no">
        <Text>Marque</Text>
        <Autocomplete
          sx={{ width: window.innerWidth > 600 ? 400 : 300 }}
          id={"brand"}
          options={brands}
          onInputChange={(event, selectBrand) =>
            setFieldValue("vehicle[brand]", selectBrand)
          }
          renderInput={(params) => (
            <CssTextField 
              {...params} 
              name="vehicle[brand]" 
            />
          )}
        />
      </InputGroup>
      <InputGroup gap="no">
        <Text>Modèle</Text>
        {
          <Autocomplete
            sx={{ width: window.innerWidth > 600 ? 400 : 300 }}
            id={"model"}
            options={models}
            onInputChange={(event, selectModel) =>
              setFieldValue("vehicle[model]", selectModel)
            }
            renderInput={(params) => (
              <CssTextField 
                {...params} 
                name="vehicle[model]" 
              />
            )}
          />
        }
      </InputGroup>

      <Box>

        
        { /* 

        <Button 
          sx={{ width: "fit-content", margin: "10px 0px", textTransform: "none", color: "var(--color-n-900" }}
          onClick={() => {
            values.vehicle.type = "notfound";
            Component = BaseComponent;
          }}
        >
          Je ne trouve pas mon véhicule
        </Button>
        
        */}

        <TypePicker.Root fieldName="vehicle[type]">
          <TypePicker.OptionsGroup direction="row">
            <TypePicker.Option 
              discrete
              value="notfound"
            >
              Je ne trouve pas mon véhicule
            </TypePicker.Option>
          </TypePicker.OptionsGroup>
        </TypePicker.Root>

        { /*
          <Autocomplete
            sx={{ width: 400 }}
            id={"model"}
            options={models}
            onInputChange={(event, selectModel) =>
              setFieldValue("vehicle[model]", selectModel)
            }
            renderInput={(params) => (
              <CssTextField 
                {...params} 
                name="vehicle[model]" 
              />
            )}
          />
          */
        }
      </Box>

      {/* 
        <Box none={shouldDisplayConsumptionInput}>
          <div style={{ borderBottom: "1px dotted #000", margin: "1rem 0rem", width: "fit-content", cursor: "pointer" }}>
            <Text marginY="m0" onClick={handleClick}>Je ne trouve pas mon véhicule</Text>
          </div>
        </Box>
      */}
      
      
      <Box hidden={!shouldDisplayConsumptionInput}>
        <TypePicker.Root fieldName="vehicle[fuel]">
          <TypePicker.Label as={Text}>Carburant</TypePicker.Label>
          <TypePicker.OptionsGroup direction="row">
            {availableFuels.map((availableFuel) => <TypePicker.Option key={availableFuel} value={availableFuel}>
              {availableFuel}
            </TypePicker.Option>)}
          </TypePicker.OptionsGroup>
        </TypePicker.Root>
      </Box>
      
        {/* 

          <TypePicker.Root fieldName="vehicle[isRegistrationYearKnown]">
            <TypePicker.Label as={Text}>
              Connaissez-vous l’année de sa mise en circulation ?
            </TypePicker.Label>
            <TypePicker.OptionsGroup direction="row">
              <TypePicker.Option value="YES">Oui</TypePicker.Option>
              <TypePicker.Option value="NO">Non</TypePicker.Option>
            </TypePicker.OptionsGroup>
          </TypePicker.Root>
          <InputGroup
            hidden={values.vehicle.isRegistrationYearKnown !== "YES"}
            gap="no"
          >

          <Text>Année de mise en circulation</Text>
            <CssSelect
              sx={{ width: 200 }}
              id="vehicle[registrationYear]"
              value={
                values.vehicle.registrationYear
                  ? `${values.vehicle.registrationYear}`
                  : ""
              }
              onChange={setRegistrationYear}
            >
              {availableYears.map((availableYear) => (
                <MenuItem value={availableYear}>{availableYear}</MenuItem>
              ))}
            </CssSelect>
          </InputGroup>
        
        */}
    </Box>
  );
};

const BaseComponent = () => {
  const fuelTypes = Object.keys(Fuel);
  const { values } = useFormikContext<FormValues>();
  const shouldDisplayConsumptionInput = values.vehicle.type === "bike";
  return (
    <Box col>
      <Heading marginY="m0" size="h5" uppercase="true">Votre véhicule</Heading>
      <TypePicker.Root fieldName="vehicle[type]">
        <TypePicker.Label as={Text}>Quel véhicule avez-vous ?</TypePicker.Label>
        <TypePicker.OptionsGroup direction="row">
          <TypePicker.Option value="car">VOITURE</TypePicker.Option>
          <TypePicker.Option value="bike">MOTO</TypePicker.Option>
        </TypePicker.OptionsGroup>
      </TypePicker.Root>

      <Box hidden={!shouldDisplayConsumptionInput} col gap="l">

        <TypePicker.Root fieldName="vehicle[fuel]">
          <TypePicker.Label as={Text}>Carburant</TypePicker.Label>
          <TypePicker.OptionsGroup direction="row">
            {fuelTypes.map((fuelType) => {
              return (
                <TypePicker.Option key={fuelType} value={fuelType}>
                  {fuelType}
                </TypePicker.Option>
              );
            })}
          </TypePicker.OptionsGroup>
        </TypePicker.Root>

        <SliderInput.Root fieldName="vehicle[consumption]">
          <SliderInput.Label>
            Quelle est la consommation (L/100km) indiquée par le constructeur de
            votre vehicule ?
          </SliderInput.Label>
          <SliderInput.Input
            max={20}
            step={0.1}
            value={values.vehicle.consumption}
            unit="L/100km"
          />
        </SliderInput.Root>
      </Box>
    </Box>
  );
};

const NotFoundComponent = () => {
  const fuelTypes = Object.keys(Fuel);
  const { values } = useFormikContext<FormValues>();
  const shouldDisplayConsumptionInput = true;
  return (
    <Box col>
      <Heading marginY="m0" size="h5" uppercase="true">Votre véhicule</Heading>
      <TypePicker.Root fieldName="vehicle[type]">
        <TypePicker.Label as={Text}>Quel véhicule avez-vous ?</TypePicker.Label>
        <TypePicker.OptionsGroup direction="row">
          <TypePicker.Option value="car">VOITURE</TypePicker.Option>
          <TypePicker.Option value="bike">MOTO</TypePicker.Option>
          <TypePicker.Option value="notfound">NE TROUVE PAS</TypePicker.Option>
        </TypePicker.OptionsGroup>
      </TypePicker.Root>

      <Box hidden={!shouldDisplayConsumptionInput} col gap="l">

        <TypePicker.Root fieldName="vehicle[fuel]">
          <TypePicker.Label as={Text}>Carburant</TypePicker.Label>
          <TypePicker.OptionsGroup direction="row">
            {fuelTypes.map((fuelType) => {
              return (
                <TypePicker.Option key={fuelType} value={fuelType}>
                  {fuelType}
                </TypePicker.Option>
              );
            })}
          </TypePicker.OptionsGroup>
        </TypePicker.Root>

        <SliderInput.Root fieldName="vehicle[consumption]">
          <SliderInput.Label>
            Quelle est la consommation (L/100km) indiquée par le constructeur de
            votre vehicule ?
          </SliderInput.Label>
          <SliderInput.Input
            max={20}
            step={0.1}
            value={values.vehicle.consumption}
            unit="L/100km"
          />
        </SliderInput.Root>
      </Box>
    </Box>
  );
};

const VehicleStepContent = () => {
  const { values, setFieldValue } = useFormikContext<FormValues>();

  // total steps
  const total = TotalSteps;
  const increment = (1/total) * 400;
  let counterProgress = (3/total) * 400;

  const car_filled = Boolean(values.vehicle.type === "car");
  const model_filled = Boolean(values.vehicle.model !== "unknown");
  const brand_filled = Boolean(values.vehicle.brand !== "unknown");
  const fuel_filled = Boolean(values.vehicle.fuel !== "unknown");
  const conso_filled = Boolean(values.vehicle.consumption > 0);
  // const registration_filled = Boolean(values.vehicle.registrationYear !== "unknown");

  if (car_filled) {
    counterProgress += increment;
  }
  if (model_filled) {
    counterProgress += increment;
  }
  if (brand_filled) {
    counterProgress += increment;
  }
  if (fuel_filled) {
    counterProgress += increment;
  }
  if (conso_filled) {
    counterProgress += increment;
  }

  if (values.vehicle.isRegistrationYearKnown === "NO") {
    counterProgress += increment*2;
  }

  const shouldDisableLink = (): boolean => {

    if (values.vehicle.type === "bike" && values.vehicle.consumption > 0)
      return false;
    if (values.vehicle.type === "notfound" && values.vehicle.consumption > 0)
      return false;
    if (
      values.vehicle.type === "car" &&
      values.vehicle.brand !== "unknown" &&
      values.vehicle.model !== "unknown" &&
      values.vehicle.fuel !== "unknown" 
      /* &&
      (values.vehicle.isRegistrationYearKnown === "NO" ||
        (values.vehicle.isRegistrationYearKnown === "YES" &&
          values.vehicle.registrationYear !== "unknown"))
          */
    )
      return false;
    return true;
  };

  let Component;

  if (values.vehicle.type === "notfound") {
    Component = NotFoundComponent;
  } else if (values.vehicle.type === "car") {
    Component = CarComponent;
  } else {
    Component = BaseComponent;
  }

  return (
    <SimulatorLayout
      dynNumber={counterProgress}
      isFirstStep={false}
      onPreviousClick={() => setFieldValue("addresses.submitted", false)}
      isLastStep={false}
      isCtaDisabled={shouldDisableLink()}
      onCtaClick={() => setFieldValue("vehicle.submitted", true)}
    >
      <Box padding={{ inline_end: "xl", inline_start: "xl" }}>
        <Component />
      </Box>
      
    </SimulatorLayout>
  );
};

export { VehicleStepContent };
